module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-oyster-abstract-balmoral-1.38e3d644.jpg";